// extracted by mini-css-extract-plugin
export default {"message":"message__5ZXfy","actions":"actions__L0-8T"};